import { defaultDataphone } from "./state";

export function setPerPage(state, perPage) {
    state.params.page = 1;
    state.params.perPage = perPage;
}

export function setPage(state, page) {
    state.params.page = page;
}

export function clearSelectedModel(state) {
    state.selectedDataphone = defaultDataphone();
}

export function setActionForm(state, action) {
    state.actionForm = action;
}
export function setdisabledInputs(state, disabled) {
    state.disabledInputs = disabled;
}

export function setDataphones(state, dataphones){
    state.dataphones=dataphones.data.data;
}

export function setSelectedDataphone(state, selectedDataphone){
   state.selectedDataphone=selectedDataphone;
}





// WEBPACK FOOTER //
// ./src/modules/dataphones/mutations.js